export default {
    // 查询第三方接口配置信息
    queryConfigThirdParty(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/thirdPartyController/queryConfigThirdParty', params, response);
    },
    // 添加第三方接口配置信息
    insertThirdPartyInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/thirdPartyController/insertThirdPartyInfo', params, response);
    },

    // 更新第三方接口配置信息
    updateThirdPartyInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/thirdPartyController/updateThirdPartyInfo', params, response);
    },

    // 删除第三方接口配置信息
    deleteConfigThirdParty(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/thirdPartyController/deleteConfigThirdParty', params, response);
    },
    // 第三方接口连接测试
    testThirdPartyUrl(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/thirdPartyController/testThirdPartyUrl', params, response);
    },
    // 同步第三方接口配置
    syncThirdPartyConfig(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/thirdPartyController/syncThirdPartyConfig', params, response);
    }
};
